import styled, { createGlobalStyle } from "styled-components";
import { media, breakpoints } from "../../components/common/mixins";

export const PaobcScopedGlobalStyle = createGlobalStyle`
    #main-wrapper {
      padding: 0;
      margin-bottom: 0;
    }

    #main-wrapper * {
      font-family: inherit;
    }

    html {
      scrollbar-color: #3EAF3F transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #3EAF3F;
    }
`;

export const ContentSection = styled.div`
  position: relative;

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const HeroBanner = styled.div`
  position: relative;
  height: clamp(222px, 41vw, 524px);

  ${media.below(breakpoints.mobile)} {
    height: 222px;
  }
`;

export const HeroBannerMedia = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
`;

export const HeroBannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const HeroBannerText = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
`;

export const EventsGrid = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  grid-template-columns: 1fr;

  ${media.above(breakpoints.mobile)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.above(breakpoints.tablet)} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.above(breakpoints.desktop)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const EventsContainer = styled.div`
  padding-top: 64px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 160px;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 364px;
  width: 100%;
`;

export const EmptyStateText = styled.p`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--Colors-Dark-Blue-dark-blue-900, #0d0c1c);
  text-align: center;
`;

export const EventsTitle = styled.h3`
  font-size: 24px;
  line-height: normal;
  margin: 0;

  ${media.below(breakpoints.mobile)} {
    font-size: 16px;
  }
`;